<form [formGroup]='consentMovers' (ngSubmit)='onSubmit()' id='{{formGroupName}}'>

	<div *ngIf='!this.formService.fccLoading' class='step-title' i18n>Your <span class='color-blue'>Top 5</span> moving companies</div>

	<div *ngIf='this.formService.fccLoading' class='loader'>
		<div class='loader-spinner'></div>
	</div>

	<!-- Only rendered once at least one mover actually comes back verified -->
	<div class='verified-explainer' #verifiedExplainer *ngIf='!this.formService.fccLoading && hasVerifiedMovers'>

		<button class='verified-explainer-trigger' #verifiedExplainerTrigger
		        type='button'
		        [attr.aria-expanded]='explainerOpen'
		        aria-controls='verified-explainer-panel'
		        [tabIndex]='formService.verifyTabIndex(formGroupName)'
		        (click)='toggleExplainer()' i18n='@@moverVerifiedExplainerLink'>What is a verified company?</button>

		<div class='verified-explainer-panel' id='verified-explainer-panel' *ngIf='explainerOpen'>

			<div class='verified-explainer-panel-header'>
				<div class='verified-explainer-panel-title' i18n='@@moverVerifiedExplainerTitle'>Verified company</div>
				<button class='verified-explainer-panel-close'
				        type='button'
				        aria-label='Close'
				        i18n-aria-label='@@moverVerifiedExplainerClose'
				        (click)='closeExplainer()'>
					<mat-icon svgIcon='vc:close'></mat-icon>
				</button>
			</div>

			<div class='verified-explainer-panel-intro' i18n='@@moverVerifiedExplainerIntro'>A Verified badge means Sirelo has checked this company's:</div>

			<ul class='verified-explainer-panel-items'>
				<li>
					<mat-icon svgIcon='icons:check'></mat-icon>
					<span i18n='@@moverVerifiedItemAssociations'>Associations</span>
				</li>
				<li>
					<mat-icon svgIcon='icons:check'></mat-icon>
					<span i18n='@@moverVerifiedItemInsurance'>Insurance information</span>
				</li>
				<li>
					<mat-icon svgIcon='icons:check'></mat-icon>
					<span i18n='@@moverVerifiedItemPermits'>Permits</span>
				</li>
				<li>
					<mat-icon svgIcon='icons:check'></mat-icon>
					<span i18n='@@moverVerifiedItemCoc'>Chamber of Commerce number</span>
				</li>
			</ul>

			<div class='verified-explainer-panel-footnote' i18n='@@moverVerifiedExplainerFootnote'>Companies without the badge haven't completed these checks. They can still quote for your move.</div>
		</div>
	</div>

	<app-consent-movers-list
		*ngIf='!this.formService.fccLoading'
		[movers]="allMovers"
		[displayedIndices]="displayedIndices"
		[form]="consentMovers"
		[viewMode]="'default'"
		(openModal)="openModal()">
	</app-consent-movers-list>

	<!-- Validation error message -->
	<div *ngIf="consentMovers.touched && consentMovers.errors?.['noMoverSelected']" class="error-message" i18n>
		Please select at least one moving company to continue
	</div>

	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'>
				<mat-icon svgIcon='icons:chevron-left'></mat-icon>
				<ng-container i18n='@@buttonBack'>Back</ng-container>
			</button>
			<button class='submit'
			        type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container>
				<mat-icon svgIcon='icons:chevron-right'></mat-icon>
			</button>
		</div>
	</div>

</form>